"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var Alert_1 = __importDefault(require("./Alert"));
exports.Alert = Alert_1.default;
exports.default = Alert_1.default;
//# sourceMappingURL=index.js.map